module.exports = __webpack_public_path__ + "quotezone-ui/img/rim-white.d0ad1f50.gif";